import { MutationTree } from 'vuex';
import { IEditorUiState, IUpdateRequest } from '@/editor/editor-block/store/editor-ui.types';
import {
  EEditorUiMutation,
  state as initialState,
} from '@/editor/editor-block/store/editor-ui.constants';
import {
  IStoredImage,
  ISelection,
  IMenuCommand,
  ITextMenuState,
  IImageMenuState,
  IHover,
  IEditorBlock,
} from '@/editor/types';
import { EContext } from '@/editor/types/enums';

export const mutations: MutationTree<IEditorUiState> = {
  [EEditorUiMutation.SetContext](state: IEditorUiState, context: EContext) {
    state.context = context;
  },

  [EEditorUiMutation.SetSelection](state: IEditorUiState, selected: ISelection) {
    state.selected = { ...selected };
  },

  [EEditorUiMutation.ResetSelection](state: IEditorUiState) {
    state.selected = undefined;
  },

  [EEditorUiMutation.SetHover](state: IEditorUiState, hovered: IHover) {
    state.hovered = { ...hovered };
  },

  [EEditorUiMutation.ResetHover](state: IEditorUiState) {
    state.hovered = undefined;
  },

  [EEditorUiMutation.UpdateTextMenuState](state: IEditorUiState, textMenuState: ITextMenuState) {
    state.textMenuState = textMenuState;
  },

  [EEditorUiMutation.UpdateImageMenuState](state: IEditorUiState, imageMenuState: IImageMenuState) {
    state.imageMenuState = {
      ...initialState.imageMenuState,
      ...imageMenuState,
    };
  },

  [EEditorUiMutation.TriggerMenuCommand](state: IEditorUiState, menuCommand: IMenuCommand) {
    state.menuCommand = menuCommand;
  },

  [EEditorUiMutation.SetBlockToUpdate](state: IEditorUiState, block: IEditorBlock) {
    state.blockToUpdate = block;
  },

  [EEditorUiMutation.SetImageUploaded](
    state: IEditorUiState,
    { contentId, image }: { contentId: string; image: IStoredImage }
  ) {
    state.imageUpload = {
      imageUploaded: image,
      isUploading: false,
      imageUploadFailed: false,
      contentId,
    };
  },

  [EEditorUiMutation.SetImageUploading](state: IEditorUiState) {
    state.imageUpload = {
      ...state.imageUpload,
      imageUploadFailed: false,
      isUploading: true,
    };
  },

  [EEditorUiMutation.SetImageUploadFailed](
    state: IEditorUiState,
    { contentId }: { contentId: string }
  ) {
    state.imageUpload = {
      ...state.imageUpload,
      isUploading: false,
      imageUploaded: undefined,
      imageUploadFailed: true,
      contentId,
    };
  },

  [EEditorUiMutation.ResetImageUpload](state: IEditorUiState) {
    state.imageUpload = {
      imageUploaded: undefined,
      imageUploadFailed: false,
      isUploading: false,
      contentId: undefined,
    };
  },

  [EEditorUiMutation.EnqueueRequest](state: IEditorUiState, requestPayload: IUpdateRequest) {
    state.updateQueue = [...state.updateQueue, requestPayload];
  },

  [EEditorUiMutation.DequeueRequest](state: IEditorUiState) {
    state.updateQueue.shift();
  },

  [EEditorUiMutation.SetIsUpdating](state: IEditorUiState, updating: boolean) {
    state.isUpdating = updating;
  },

  [EEditorUiMutation.EmptyQueue](state: IEditorUiState) {
    state.updateQueue = [];
  },
};
